import React from 'react';

const AppointmentOption = ({ option ,setTreatment}) => {
    const { name, slots,price } = option;
    return (
        <div>
            <div className="card w-96 bg-base-100 shadow-xl my-10">
                <div className="card-body">
                    <h2 className="lg:text-3xl text-info font-bold text-center">{name}</h2>
                    <p className='text-center'>{slots.length > 0 ? slots[0] : 'Try Another Date'}</p>
                    <p className='text-center'>{slots.length} {slots.length > 1 ? 'spaces' : 'space'}</p>
                    <p className='text-center text-yellow-700'>Price:{price}$</p>

                    <div className="card-actions justify-center">
                  
                    <label htmlFor="booking-modal"
                     className="btn btn-info text-white"
                     onClick={()=> setTreatment(option)}
                     >
                        Book Appointment</label>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default AppointmentOption;